import {
  ApiStateRecord,
  generateInitApiState
} from '@exxonmobil/uit-uda-ui-components-lib';

import { WorkCenter } from 'models/workcenters';

import { BaselinesData, WorkCenterBaseline } from 'models/baselines';

/* ******************* The provider component ******************* */
export const fetchingBaselinesMessage: string = 'Fetching baselines ...';
export const updatingBaselinesMessage: string = 'Updating baselines ...';
export const approvingBaselineMessage: string = 'Approving baselines ...';

export type BaselinesProviderValueType = {
  stateRecord: ApiStateRecord<WorkCenterBaseline[]>;
  getBaselines: () => Promise<any>;
  getWorkCenters: () => Promise<any>;
  updateBaselineSelection: Function;
  updateBaselineSelectionAll: Function;
  updateMode: Function;
  cloneApprovedToRequested: Function;
  workCenters: WorkCenter[];
  isUserApprover: boolean;
  rejectSelected: () => Promise<PromiseSettledResult<Response>[]>;
  approveSelected: () => Promise<PromiseSettledResult<Response>[]>;
};

export const defaultBaselinesState = generateInitApiState<BaselinesData[]>([]);
export const defaultWorkCentersState = generateInitApiState<WorkCenter[]>([]);
export const defaultFullBaselinesState = generateInitApiState<
  WorkCenterBaseline[]
>([]);

export const initStateDataValue: BaselinesProviderValueType = {
  stateRecord: {
    state: defaultFullBaselinesState,
    setState: () => {},
    resetState: () => {},
    defaultDataValue: defaultFullBaselinesState.data
  },
  getBaselines: async () => {},
  getWorkCenters: async () => {},
  updateBaselineSelection: () => {},
  updateBaselineSelectionAll: () => {},
  updateMode: () => {},
  cloneApprovedToRequested: () => {},
  workCenters: [],
  isUserApprover: false,
  rejectSelected: async () => [],
  approveSelected: async () => []
};
